import React from 'react'
import PropTypes from 'prop-types'
import Filter from '../Filter/Filter'
import styles from './FilterModule.module.scss'

const FilterModule = props => {
  const renderRemoveFilter = () =>
    (props.filters &&
      props.filters.map(({ field, type, value, _id }) => (
        <Filter
          values={props.values}
          onGAEvent={props.onGAEvent}
          filter={{ field, type, value, _id }}
          key={_id}
          onRemove={() => {
            props.onGAEvent('Remove')
            props.onRemoveFilter([
              ...props.filters.filter(({ _id: fid }) => _id !== fid),
            ])
          }}
          onSave={filter => {
            props.setFilters([
              ...props.filters.map(
                other => (_id === other.id && { ...filter, _id }) || other,
              ),
            ])
          }}
        />
      ))) ||
    null

  const renderAddFilter = () => (
    <Filter
      values={props.values}
      onGAEvent={props.onGAEvent}
      onSave={filter => {
        props.onGAEvent('Add')
        props.setFilters([...props.filters, { ...filter, _id: Math.random() }])
      }}
    />
  )

  return (
      <div className={styles.filter}>
        {renderRemoveFilter()}
        {renderAddFilter()}
      </div>
  )
}
export default FilterModule

FilterModule.propTypes = {
  filters: PropTypes.array.isRequired,
  setFilters: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  onGAEvent: PropTypes.func,
  onRemoveFilter: PropTypes.func.isRequired,
}

FilterModule.defaultProps = {
  onGAEvent: () => {},
}
